import * as Sentry from '@sentry/browser'
import { isCancel } from 'axios';

export default function(dom, opts) {
	let options = {
		...opts
	}
	if (opts.enable) {

    function handleSentryBeforeSend(event, hint) {
      if (isCancel(hint?.originalException)) {
        // console.debug('Cancelled request ignored by Sentry', hint.originalException);
        return null;
      }
      return event;
    }

		Sentry.init({
			dsn: opts.dsn,
			ignoreErrors: [
				'BetterJsPop',
				'gbIntegration.parentNode.removeChild',
				'.reading \'removeChild\')',
				'Object Not Found Matching Id',
				'find variable: ga',
				'ga is not defined',
        'ResizeObserver loop completed with undelivered notifications.',
			],
			denyUrls: [
				// Facebook flakiness
				/graph\.facebook\.com/i,
				// Facebook blocked
				/connect\.facebook\.net\/en_US\/all\.js/i,
				// Chrome extensions
				/extensions\//i,
				/^chrome:\/\//i,
				/extension:\/\//i,
				// Other plugins
				/code\.jivosite\.com/i,

			],
      beforeSend: handleSentryBeforeSend,
      allowUrls: [new RegExp(window.location.origin.replaceAll('.', '\\.'))]
		});
		Sentry.configureScope((scope) => {
			//scope.setTag("app", "selfordering")
			scope.setExtra("githash", opts.githash)
		});
	} else {
		config.DEBUG && console.warn("sentry is disabled")
	}
}
